import { render, staticRenderFns } from "./SubscribeView.vue?vue&type=template&id=40bf9c24&scoped=true&"
import script from "./SubscribeView.vue?vue&type=script&lang=js&"
export * from "./SubscribeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bf9c24",
  null
  
)

export default component.exports